module.exports = {
  title: '新增配置',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'special-config-form',
    },
  },
};
